import {
  Box,
  BoxProps,
  forwardRef,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
} from '@chakra-ui/react';

type Props = Omit<BoxProps, 'onChange'> & {
  max: number;
  min: number;
  value?: number;
  onChange: (key: number) => void;
  step?: number;
  showStepper?: boolean;
};

const InputNumber = forwardRef(
  (
    { max, min, value, onChange, step, showStepper = false, ...props }: Props,
    ref
  ) => (
    <Box {...props}>
      <NumberInput
        max={max}
        step={step}
        value={value}
        min={min}
        onChange={(_val, num) => {
          // if (num < max && num > min) onChange(num);
          onChange(num);
        }}
      >
        <NumberInputField
          ref={ref}
          borderRadius="20px"
          padding="30px 20px 20px 30px"
          color="primaryColor"
          width="300px"
          border="none"
          _focus={{
            border: '1px solid',
          }}
          fontSize={73}
          fontFamily="Primary bold"
          textAlign="center"
          height="100px"
          lineHeight="100px"
        />
        {showStepper && (
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        )}
      </NumberInput>
    </Box>
  )
);
export default InputNumber;
